var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.loader ? _c('Form', {
    attrs: {
      "url": "/tributacao/update",
      "tributacao": _vm.tributacao
    }
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };